/**
 * Segmented toggle — a compact inline toggle between 2+ options.
 * Used for introduction side selection, exclusive part groups, etc.
 */

import { cn } from '@/lib/utils';

export interface SegmentedToggleOption<T extends string | number> {
    value: T;
    label: string;
}

interface SegmentedToggleProps<T extends string | number> {
    options: readonly SegmentedToggleOption<T>[];
    value: T;
    onChange: (value: T) => void;
}

export function SegmentedToggle<T extends string | number>({
    options,
    value,
    onChange,
}: SegmentedToggleProps<T>) {
    return (
        <div className="flex gap-0.5">
            {options.map((option) => (
                <button
                    key={option.value}
                    className={cn(
                        'px-2 py-0.5 text-[10px] font-medium rounded-sm transition-colors',
                        value === option.value
                            ? 'bg-primary text-primary-foreground'
                            : 'bg-muted/60 text-muted-foreground hover:bg-muted'
                    )}
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
